var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lunbo"},[_c('el-carousel',{ref:"lunbo",attrs:{"height":"600px","interval":2000,"arrow":"always"}},_vm._l((_vm.lunboList),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{staticStyle:{"width":"100%","height":"600px"},attrs:{"src":item.imageUrl,"alt":item.title}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }